import React from "react";
import ErrorTickets from "./ErrorTickets";
import OpenTickets from "./OpenTickets";
import Resolvers from "../../../../../componets/Api/internal/serviceapi/samsung";

export default class Reports extends React.Component {
  state = {
    selectGroup: 0,
    errorTicketCnt: 0,
    openTicketCnt: 0,
    sawTicketCnt: 0,
    wbTicketCnt: 0,
    loading: false,
  };

  getCntTickets = async () => {
    this.setState({ loading: true });
    var x = await Resolvers({ ...this.props, CountTicket: true });
    x = { ...x.data[0], loading: false };
    this.setState(x);
  };

  componentDidMount() {
    this.getCntTickets();
  }

  render() {
    const { Bs, VARIANT, SIZE, _icon } = this.props;
    return (
      <>
        <Bs
          badge
          pill
          bg={VARIANT.CUSTOM}
          onClick={() => this.setState({ selectGroup: 0 })}
          className={
            this.state.selectGroup === 0
              ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
              : "c-badge me-2 mt-2 mb-2 cursor-pointer"
          }
        >
          Chyby{" "}
          <Bs badge pill bg={VARIANT.DANGER} className="ms-1">
            {this.state.loading ? 
            (<Bs brtxspin />) : (this.state.errorTicketCnt)
            }
          </Bs>
        </Bs>
        <Bs
          badge
          pill
          bg={VARIANT.CUSTOM}
          onClick={() => this.setState({ selectGroup: 1 })}
          className={
            this.state.selectGroup === 1
              ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
              : "c-badge me-2 mt-2 mb-2 cursor-pointer"
          }
        >
          Otevřené{" "}
          <Bs badge pill bg={VARIANT.SUCCESS} className="ms-1">
            {this.state.loading ? 
            (<Bs brtxspin />) : (this.state.openTicketCnt)
            }
          </Bs>
        </Bs>
        <Bs
          badge
          pill
          bg={VARIANT.CUSTOM}
          onClick={() => this.setState({ selectGroup: 2 })}
          className={
            this.state.selectGroup === 2
              ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
              : "c-badge me-2 mt-2 mb-2 cursor-pointer"
          }
        >
          SAW žádosti{" "}
          <Bs badge pill bg={VARIANT.INFO} className="ms-1">
            {this.state.loading ? (
              <Bs
                spinner
                as="span"
                animation="border"
                size={SIZE.SM}
                role="status"
                aria-hidden="true"
              />
            ) : (
              this.state.sawTicketCnt
            )}
          </Bs>
        </Bs>
        <Bs
          badge
          pill
          bg={VARIANT.CUSTOM}
          onClick={() => this.setState({ selectGroup: 3 })}
          className={
            this.state.selectGroup === 3
              ? "active-badge c-badge me-2 mt-2 mb-2 cursor-pointer"
              : "c-badge me-2 mt-2 mb-2 cursor-pointer"
          }
        >
          Warranty Bill's{" "}
          <Bs badge pill bg={VARIANT.PRIMARY} className="ms-1">
            {this.state.loading ? (
              <Bs
                spinner
                as="span"
                animation="border"
                size={SIZE.SM}
                role="status"
                aria-hidden="true"
              />
            ) : (
              this.state.wbTicketCnt
            )}
          </Bs>
        </Bs>
        <Bs row className="mt-2">
          <Bs col xs={12}>
            <Bs card bg={VARIANT.UNI} className="mb-4">
              <Bs cardbody>
                <Bs row>
                  <Bs col xs={12}>
                    <Bs row className="d-flex justify-content-start">
                      <Bs col xs={12} lg={9}>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Zobrazit FiFo vazby"
                        >
                          <_icon facodebranch />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Historie zakázky"
                        >
                          <_icon bslist className="fs-20" />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="BOM list z IGSPN"
                        >
                          <_icon cglisttree />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Hromadné odeslání souborů"
                        >
                          <_icon cgsoftwareupload className="fs-20" />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Zničit FiFo vazby"
                        >
                          <_icon cgplaylistremove className="fs-20" />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Načíst XML pro úpravu"
                        >
                          <_icon cgcodeslash className="fs-20" />
                        </Bs>
                        <Bs
                          button
                          size={SIZE.SM}
                          variant={VARIANT.LIGHT}
                          className="me-2"
                          data-tip="Historie na IGSPN"
                        >
                          <_icon fahistory />
                        </Bs>
                      </Bs>
                      <Bs
                        col
                        xs={12}
                        lg={3}
                        className="d-flex justify-content-end"
                      >
                        <Bs formcontrol placeholder="Filtrovat" />
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
        {this.state.selectGroup === 0 && <ErrorTickets {...this.props} refreshCount={this.getCntTickets}/>}
        {this.state.selectGroup === 1 && <OpenTickets {...this.props} refreshCount={this.getCntTickets}/>}
      </>
    );
  }
}
